export enum ImpuestosFuente {
  TRIBUTOS= 'tributo',
  TRAMITES = 'tramite'
}
